/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../../static/scss/resources/default.variables.scss';
@import '../../../../static/scss/resources/default.style.scss';

.bg-user-invalid {
  @extend .bg-warning-light;
}

.user_container {
  border-bottom: $panel-border;
  height: 100%;
  min-height: 0;
  margin-top: $title-height;
}

.user_management {
  height: 100%;
  overflow: hidden;

  & .navtab-inline-controls {
    position: absolute;
    width: 100%;
  }
}

.user_management .search_users form {
  margin: 0;
}

.user_management table {
  display: block;
  height: 100%;
  overflow: auto;
  border: 0 none;
}

.user_management .backform-tab {
  height: calc(100% - 75px);
}
